// rootReducer.js
import { combineReducers } from 'redux';
import loaderReducer from './loaderReducer'; // Import your individual reducers
import { modalReducer } from './modalReducer';
import checkedItemsReducer from './setItemsAction';

const rootReducer = combineReducers({
    loader: loaderReducer,
    modal:modalReducer,
    checkedItems: checkedItemsReducer,
    // Add other reducers here
});

export default rootReducer;